import Card from "../UI/Card";
import classes from "./Photos.module.css";
import Modal from "../UI/Modal";
import { useState } from "react";

const Photos = (props) => {
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState("");

  const zoomInHandler = (photo) => {
    setCurrentPhoto(photo);
    setIsZoomedIn(true);
  };

  const closePhotoHandler = () => {
    setIsZoomedIn(false);
  };

  const content = props.photos.photos.map((photo) => (
    <img key={photo} onClick={() => zoomInHandler(photo)} src={photo} alt="" />
  ));

  return (
    <Card>
      <div className={classes.wrapper}>{content}</div>
      {isZoomedIn && (
        <Modal onHidePhoto={closePhotoHandler} photo={currentPhoto} />
      )}
    </Card>
  );
};

export default Photos;
